import { Icon } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { SurveyStep } from '../../models';

export interface ISurveyStepItemProps {
	id: string;
	step: SurveyStep;
	isActive: boolean;
	disabled: boolean;
	hasNote: boolean;
	onClick: () => void;
}

export interface ISurveyStepItemState {
	showSubSteps: boolean;
}

export const SurveyStepItemContainer = styled.div.attrs<{}>({
	className: 'tws-survey-step-item',
})`
	font-weight: 600;
	margin: 10px 0;

	.toggle {
		margin: 8px 0 0 8px;
		line-height: 1.5;
	}
`;

export const Sequence = styled.div.attrs<{ isActive: boolean }>({
	className: 'tws-survey-step-sequence',
})<{ isActive: boolean }>`
	background-color: ${(props) => (props.isActive ? '#0080A5' : globalVars.gray5)};
	border-radius: 50%;
	color: ${globalVars.white};
	display: inline-block;
	height: 26px;
	margin: 0 10px;
	text-align: center;
	vertical-align: middle;
	width: 26px;

	span {
		font-size: 14px;
		line-height: 14px;
		position: relative;
		top: 3px;
	}
`;
Sequence.displayName = 'Sequence';

export const StepText = styled.div.attrs<{ isActive: boolean; disabled: boolean }>({
	className: 'tws-survey-step-displaytext',
})<{ isActive: boolean; disabled: boolean }>`
	color: ${(props) => (props.isActive ? globalVars.mainBlue : globalVars.gray3)};
	display: inline-block;
	font-size: 13.5px;
	line-height: 16px;
	vertical-align: middle;

	${(props) =>
		props.disabled || props.isActive
			? 'pointer-events: none;'
			: `cursor: pointer;
		:hover {
			color: ${globalVars.mainBlue};
		}`}
`;
StepText.displayName = 'StepText';

export const StepNote = styled(Icon)`
	color: ${globalVars.gray3};
	margin: 8px 0 0 8px;
`;
StepNote.displayName = 'StepNote';

export class SurveyStepItem extends React.Component<
	React.PropsWithChildren<React.PropsWithChildren<ISurveyStepItemProps>>,
	ISurveyStepItemState
> {
	constructor(props: ISurveyStepItemProps) {
		super(props);

		this.state = {
			showSubSteps: true,
		};

		this.toggleShowSubSteps = this.toggleShowSubSteps.bind(this);
	}

	public render() {
		const { disabled, id, isActive, hasNote, children } = this.props;
		return (
			<SurveyStepItemContainer id={id}>
				<Sequence isActive={isActive}>
					<span>{this.getSequence()}</span>
				</Sequence>
				<StepText isActive={isActive} disabled={disabled} onClick={() => (disabled ? null : this.props.onClick())}>
					{this.getDisplayText()}
				</StepText>
				{hasNote ? <StepNote name='note' /> : null}
				{children && (
					<Icon
						name={this.state.showSubSteps ? 'angle-down' : 'angle-up'}
						className='toggle'
						onClick={() => this.toggleShowSubSteps(!this.state.showSubSteps)}
					/>
				)}
				{this.state.showSubSteps && children}
			</SurveyStepItemContainer>
		);
	}

	public getSequence() {
		switch (this.props.step) {
			case SurveyStep.BrandingAndTheme:
			case SurveyStep.LogicAndLayout:
				return 3;
			default:
				return this.props.step;
		}
	}

	public getDisplayText() {
		switch (this.props.step) {
			case SurveyStep.Basics:
				return ContentConstants.STEPPER_STEP_BASICS;

			case SurveyStep.Define:
				return ContentConstants.STEPPER_STEP_DEFINE;

			case SurveyStep.BrandingAndTheme:
				return ContentConstants.STEPPER_STEP_DESIGN_YOUR_SURVEY;

			case SurveyStep.Distribution:
				return ContentConstants.STEPPER_STEP_DISTRIBUTION;

			case SurveyStep.Reporting:
				return ContentConstants.STEPPER_STEP_REPORTING;

			case SurveyStep.Confirm:
				return ContentConstants.STEPPER_STEP_CONFIRM;
		}
	}

	public toggleShowSubSteps(showSubSteps: boolean) {
		this.setState({ showSubSteps: showSubSteps });
	}
}
